import { useState } from "react";
import { motion, useReducedMotion } from "framer-motion";
import { mediaUrl, waLink } from "@/lib/api";
import { WhatsAppIcon } from "./icons";

const pickVideo = (s) => {
  const mobile = typeof window !== "undefined" && window.matchMedia("(max-width: 767px)").matches;
  return mediaUrl((mobile && s.hero_video_mobile_url) || s.hero_video_url);
};

export const Hero = ({ s }) => {
  const reduce = useReducedMotion();
  const [failed, setFailed] = useState(false);
  const src = pickVideo(s);
  const poster = mediaUrl(s.hero_fallback_image);
  const showVideo = src && !failed && !reduce;
  const fade = (d) => ({ initial: { opacity: 0, y: 24 }, animate: { opacity: 1, y: 0 }, transition: { duration: 1.1, delay: d, ease: [0.22, 1, 0.36, 1] } });

  return (
    <section id="inicio" data-testid="hero-section" className="relative h-[100svh] min-h-[600px] w-full overflow-hidden bg-[#08080A] grain">
      {poster && <img src={poster} alt="" aria-hidden="true" data-testid="hero-fallback-image" className="absolute inset-0 h-full w-full object-cover" fetchpriority="high" />}
      {showVideo && (
        <video
          key={src}
          data-testid="hero-video"
          className="absolute inset-0 h-full w-full object-cover"
          src={src}
          poster={poster || undefined}
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          disablePictureInPicture
          aria-hidden="true"
          onError={() => setFailed(true)}
        />
      )}
      <div className="absolute inset-0 bg-gradient-to-b from-[#08080A]/70 via-[#08080A]/45 to-[#08080A]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_30%,rgba(8,8,10,0.55)_100%)]" />

      <div className="relative z-10 h-full mx-auto max-w-7xl px-5 sm:px-8 lg:px-12 flex flex-col justify-end pb-28 sm:pb-32 lg:justify-center lg:pb-0">
        {s.hero_badge && (
          <motion.p {...fade(0.2)} className="label-caps mb-6" data-testid="hero-badge">
            {s.hero_badge}
          </motion.p>
        )}
        <motion.h1 {...fade(0.35)} data-testid="hero-title" className="font-display font-normal text-white text-5xl sm:text-6xl lg:text-8xl leading-[0.95] tracking-[0.04em] max-w-4xl">
          {s.hero_title}
        </motion.h1>
        <motion.p {...fade(0.55)} data-testid="hero-subtitle" className="mt-7 max-w-xl text-base sm:text-lg text-[#D4D4D8] leading-relaxed font-light">
          {s.hero_subtitle}
        </motion.p>
        <motion.div {...fade(0.75)} className="mt-10 flex flex-col sm:flex-row gap-4">
          <a href="#acomodacoes" className="btn-lux bg-white/5 backdrop-blur-sm" data-testid="hero-accommodations-button">
            {s.btn_accommodations}
          </a>
          <a href={waLink(s.whatsapp_number, s.wa_msg_default)} target="_blank" rel="noopener noreferrer" className="btn-lux btn-gold" data-testid="hero-whatsapp-button">
            <WhatsAppIcon className="w-4 h-4" /> {s.btn_whatsapp}
          </a>
        </motion.div>
      </div>

      <a href="#acomodacoes" aria-label="Rolar para a próxima seção" data-testid="hero-scroll-indicator" className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 hidden sm:flex flex-col items-center gap-3 text-[0.6rem] uppercase tracking-[0.3em] text-white/60 hover:text-white transition-colors">
        Role
        <span className="relative h-12 w-px bg-white/15 overflow-hidden">
          <span className="scroll-cue absolute inset-x-0 top-0 h-1/2 bg-white/80" />
        </span>
      </a>
    </section>
  );
};
